<template>
  <a
    :href="block.data.url"
    :class="['file-document-access', $route.name === 'map' ? 'file-document-access-map' : '']"
    target="_blank"
  >
    <span class="file-document-access-icon">
      <i class="far fa-link text-color-content-link"></i>
    </span>
    <span class="file-document-access-info">
      <span class="file-document-access-info-name">
        {{ block.data.url }}
      </span>
      <span class="file-document-access-info-action">
        <i class="far fa-external-link-alt"></i>
      </span>
    </span>
  </a>
</template>

<script>
export default {
  name: 'MoleculeContentNodeBlockLink',

  props: {
    block: Object
  }
}
</script>
